//TODO: Remove the unused interfaces after hooking up with backend data

enum ModalForm {
    ADD_CUSTOMER_PARENT = 'addCustomerParent',
    EDIT_CUSTOMER_PARENT = 'editCustomerParent',
    EMPTY = '',
}

export interface Option {
    id: number | string;
    name: string | number;
    disabled?: boolean;
}

export { ModalForm };
